import { render, staticRenderFns } from "./UploadAttachment.vue?vue&type=template&id=3f3e7f44&"
import script from "./UploadAttachment.vue?vue&type=script&lang=js&"
export * from "./UploadAttachment.vue?vue&type=script&lang=js&"
import style0 from "./UploadAttachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports